import React, { Component } from "react";
import PropTypes from "prop-types";

class WidthWrapper extends Component {
  constructor(props) {
    super(props);
    this.state = { windowWidth: window && window.innerWidth };
  }

  componentDidMount() {
    // TODO: Clean code
    const component = this;

    (function () {
      // eslint-disable-line
      let resizeTimeout;

      function actualResizeHandler() {
        // TODO: Do it on the same location (maybe as a selector)
        if (window.innerWidth !== component.state.windowWidth) {
          component.setState({ windowWidth: window.innerWidth });
        }
      }

      function resizeThrottler() {
        // ignore resize events as long as an actualResizeHandler execution is in the queue
        if (!resizeTimeout) {
          resizeTimeout = setTimeout(() => {
            resizeTimeout = null;
            actualResizeHandler();

            // The actualResizeHandler will execute at a rate of 15fps
          }, 66);
        }
      }

      window.addEventListener("resize", resizeThrottler, false);
    })();
  }

  render() {
    const { children } = this.props;
    const { windowWidth } = this.state;
    return <div>{children && React.cloneElement(children, { windowWidth })}</div>;
  }
}

WidthWrapper.propTypes = {
  children: PropTypes.object,
};

export default WidthWrapper;
